var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAeroSpace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.09091C16 14.1364 12.5867 18.8545 8 20C3.41333 18.8545 0 14.1364 0 9.09091V3.63636L8 0L16 3.63636V9.09091ZM8 18.1818C11.3333 17.2727 14.2222 13.2182 14.2222 9.29091V4.81818L8 1.98182L1.77778 4.81818V9.29091C1.77778 13.2182 4.66667 17.2727 8 18.1818ZM8 4.25455C8.44444 4.25455 8.84444 4.64545 8.84444 5.11818V8.28182L13.3333 11.1455V12.3L8.84444 10.8636V14.0182L9.96444 14.8818V15.7455L8 15.1636L6.03556 15.7455V14.8818L7.15556 14.0182V10.8636L2.66667 12.3V11.1455L7.15556 8.28182V5.11818C7.15556 4.64545 7.55556 4.25455 8 4.25455Z",
    fill: "url(#paint0_linear_590_334)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_590_334",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeroSpace);
export default __webpack_public_path__ + "static/media/AeroSpace.6c7c09625dd6ebf5c6593fb91eb1f509.svg";
export { ForwardRef as ReactComponent };